module.exports = "/images/hu.svg?a61368dbdbc96e82e1d9a674f5f53d2a";